import React from 'react'
import SeoPage from '../components/SeoPage'

import Img from '../components/Image'
import { graphql, Link } from 'gatsby'

const ContentPage = ({ data, location, ...props }) => {
    return (
        <SeoPage
            leadImage={data.img0.childImageSharp.fluid.src}
            location={location}
            title="Que se passe-t-il en cas de troisième infraction pour alcool au volant?"
            description="Nous vous expliquons les conséquences d'être reconnu coupable pour une troisième infraction de conduite avec les facultés affaiblies par l'alcool au Québec !"
            fr={undefined}
            lawType="criminal"
            specialtyText="pour Alcool au volant">
            <p>
                Si vous en êtes à votre deuxième récidive dans une période de 10
                ans, il faudra s’attendre aux conséquences suivantes:
            </p>
            <ul>
                <li>Une peine d’emprisonnement minimale de 120 jours, </li>
                <li>L’obligation d’utiliser un antidémarreur à vie, et </li>
                <li>
                    Interdiction d’acheter, de louer ou d’immatriculer un
                    véhicule.
                </li>
            </ul>
            <p>
                <Img
                    fluid={data.img0.childImageSharp.fluid}
                    title="Sanctions liées à la conduite avec les facultés affaiblies par l’alcool!"
                    alt=""
                />
            </p>
            <p>
                Une troisième infraction est lourde de conséquences. Il est donc
                important de faire appel à un avocat dès que possible pour
                préparer une bonne défense.
            </p>
            <p>
                <strong>
                    Avocats Alcool au Volant vous explique en détail toutes les
                    conséquences d’une troisième infraction d’alcool au volant!
                </strong>
            </p>
            <h2>
                <strong>
                    Quelles sont les conséquences de conduite avec facultés
                    affaiblies par l’alcool?
                </strong>
            </h2>
            <p>
                Pour saisir l'ampleur des conséquences d'une troisième
                infraction, il faut comprendre les sanctions d’une première et
                d’une deuxième condamnation. Voici un aperçu des conséquences
                pour une première, deuxième et troisième infraction de conduite
                avec les facultés affaiblies par l’alcool au Québec :
            </p>
            <h3>
                <strong>Première infraction</strong>
            </h3>
            <p>
                Lorsqu'un individu est reconnu coupable de conduite avec
                facultés affaiblies pour la première fois, les conséquences sont
                tout de même assez importantes.
            </p>
            <h4>
                <strong>1) Amende obligatoire</strong>
            </h4>
            <p>
                La loi prévoit une amende minimale obligatoire de 1 000 $ qui
                peut augmenter selon le taux d’alcool détecté dans le sang du
                conducteur.{' '}
            </p>
            <table>
                <tr>
                    <td>
                        <p>
                            <strong>Concentration d’alcool</strong>
                        </p>
                    </td>
                    <td>
                        <p>
                            <strong>Contravention minimale</strong>
                        </p>
                    </td>
                </tr>
                <tr>
                    <td>
                        <p>Entre 80 mg et 119 mg par 100 ml de sang</p>
                    </td>
                    <td>
                        <p>1 000 $</p>
                    </td>
                </tr>
                <tr>
                    <td>
                        <p>Entre 120 mg et 159 mg par 100 ml de sang</p>
                    </td>
                    <td>
                        <p>1 500 $</p>
                    </td>
                </tr>
                <tr>
                    <td>
                        <p>160 mg et plus par 100 ml de sang</p>
                    </td>
                    <td>
                        <p>2 000$ et plus</p>
                    </td>
                </tr>
            </table>
            <p>
                Le montant de l’amende minimale obligatoire varie en fonction du
                taux d’alcool détecté dans le sang. Le tribunal peut, si les
                circonstances le justifient, décider d’imposer une amende plus
                élevée.
            </p>
            <h4>
                <strong>
                    2) Suspension et révocation de son permis de conduire
                </strong>
            </h4>
            <p>
                Outre l'amende, l'individu se verra imposer une suspension
                obligatoire de son permis de conduire d'une durée minimale d'un
                an.
            </p>
            <p>
                De plus, le tribunal ordonne la révocation du permis de conduire
                pour une période d’un à trois ans, en fonction de la gravité de
                l'infraction.
            </p>
            <h4>
                <strong>3) Saisie du véhicule du conducteur</strong>
            </h4>
            <p>
                Si le taux d’alcoolémie est égal ou supérieur à 160 mg par 100
                ml de sang, ou si le conducteur{' '}
                <Link to="https://avocatsalcoolauvolant.ca/refus-souffler-alcootest/">
                    refuse de se soumettre à un alcootest
                </Link>
                , le véhicule du conducteur sera saisi dès l’arrestation.
            </p>
            <p>
                <Img
                    fluid={data.img1.childImageSharp.fluid}
                    title="Saisie du véhicule lors de l’arrestation pour alcool au volant !"
                    alt=""
                />
            </p>
            <p>
                Le véhicule sera confisqué pour une durée de 30 jours, avec des
                frais de remorquage et d’entreposage à la charge du
                propriétaire.
            </p>
            <p>
                Il est possible de demander une mainlevée de la saisie,
                permettant de récupérer le véhicule avant la fin de la période
                de 30 jours. Ce sera le cas si le conducteur n’est pas le
                propriétaire.
            </p>
            <h4>
                <strong>4) Casier judiciaire</strong>
            </h4>
            <p>
                L’infraction de conduite avec les facultés affaiblies par
                l’alcool sera inscrite au casier judiciaire du contrevenant.
            </p>
            <h4>
                <strong>5) Peine d’emprisonnement</strong>
            </h4>
            <p>
                Le tribunal peut imposer une peine d’emprisonnement pouvant
                aller jusqu'à 10 ans en fonction des circonstances entourant
                l'infraction, bien que cela soit relativement rare pour une
                première infraction.
            </p>
            <h4>
                <strong>6) Installation d’un dispositif antidémarrage</strong>
            </h4>
            <p>
                Le tribunal peut ordonner l'installation d'un antidémarreur dans
                le véhicule du contrevenant pour une durée minimale d'un an.{' '}
                <strong>7) Programmes de réduction du risque</strong>
            </p>
            <p>
                Le tribunal peut ordonner la participation au Programme
                d’évaluation et de réduction du risque de conduite avec les
                facultés affaiblies ainsi qu’au programme Alcofrein.
            </p>
            <h3>
                <strong>Deuxième infraction</strong>
            </h3>
            <p>
                Les conséquences d’une deuxième infraction de conduite avec
                facultés affaiblies sont bien plus graves!
            </p>
            <p>
                <Img
                    fluid={data.img2.childImageSharp.fluid}
                    title="Conséquences pour deuxième infraction d’alcool au volant!"
                    alt=""
                />
            </p>
            <p>
                Si la deuxième infraction survient dans les 10 ans suivant la
                première condamnation, le conducteur s'expose à des sanctions
                beaucoup plus sévères, telles que:
            </p>
            <table>
                <tr>
                    <td>
                        <p>Conséquences</p>
                    </td>
                    <td>
                        <p>Explication</p>
                    </td>
                </tr>
                <tr>
                    <td>
                        <p>
                            Suspension, révocation du permis de conduire et
                            interdiction de conduire
                        </p>
                    </td>
                    <td>
                        <p>
                            Suspension immédiate du permis de conduire pour 90
                            jours. Il n’est pas possible d’obtenir un permis
                            restreint durant cette période.Interdiction de
                            conduire d’au moins 2 ans après la condamnation.
                        </p>
                        <p>
                            Le tribunal peut ordonner la révocation du permis de
                            conduire pour une période de 3 à 5 ans.{' '}
                        </p>
                    </td>
                </tr>
                <tr>
                    <td>
                        <p>Saisie du véhicule du conducteur</p>
                    </td>
                    <td>
                        <p>
                            Le véhicule du conducteur sera saisi pendant 90
                            jours à compter de l'arrestation.
                        </p>
                    </td>
                </tr>
                <tr>
                    <td>
                        <p>Peine d’emprisonnement obligatoire</p>
                    </td>
                    <td>
                        <p>
                            En cas de deuxième condamnation dans un délai de 10
                            ans, le conducteur doit purger un emprisonnement
                            obligatoire d’au moins 30 jours.
                        </p>
                    </td>
                </tr>
                <tr>
                    <td>
                        <p>Inscription au casier judiciaire</p>
                    </td>
                    <td>
                        <p>
                            La deuxième infraction de conduite avec les facultés
                            affaiblies par l’alcool sera inscrite au casier
                            judiciaire du contrevenant.
                        </p>
                    </td>
                </tr>
                <tr>
                    <td>
                        <p>Restrictions sur les véhicules</p>
                    </td>
                    <td>
                        <p>
                            Le tribunal peut imposer des restrictions strictes
                            sur les véhicules, interdisant au conducteur
                            d’immatriculer, d’acheter, de louer ou de mettre en
                            circulation un véhicule à son nom pendant une durée
                            déterminée.
                        </p>
                    </td>
                </tr>
                <tr>
                    <td>
                        <p>Installation d’un dispositif antidémarrage</p>
                    </td>
                    <td>
                        <p>
                            Le tribunal ordonne l'installation d’un dispositif
                            antidémarrage dans le véhicule du contrevenant à
                            vie. Le conducteur peut en demander le retrait après
                            10 ans.
                        </p>
                    </td>
                </tr>
                <tr>
                    <td></td>
                    <td></td>
                </tr>
                <tr>
                    <td>
                        <p>Programme d’évaluation</p>
                    </td>
                    <td>
                        <p>
                            L’évaluation prend en compte plusieurs aspects,
                            notamment les habitudes de conduite du participant
                            et sa perception des risques liés à la conduite avec
                            les facultés affaiblies par l’alcool ou par toute
                            substance illégale.
                        </p>
                    </td>
                </tr>
            </table>
            <h3>
                <strong>Troisième infraction</strong>
            </h3>
            <p>
                Certains individus sont condamnés une troisième fois pour
                conduite avec les facultés affaiblies par l'alcool dans un délai
                de 10 ans.{' '}
            </p>
            <p>
                <Img
                    fluid={data.img3.childImageSharp.fluid}
                    title="Conséquences pour troisième infraction d’alcool au volant!"
                    alt=""
                />
            </p>
            <p>
                Voici un aperçu des conséquences détaillées liées à cette
                troisième infraction:
            </p>
            <h4>
                <strong>1) Amende et casier judiciaire</strong>
            </h4>
            <p>Vous aurez une amende à la discrétion du juge. </p>
            <p>
                La troisième condamnation pour conduite avec les facultés
                affaiblies par l'alcool sera également inscrite au casier
                judiciaire.
            </p>
            <h4>
                <strong>2) Peine d’emprisonnement obligatoire</strong>
            </h4>
            <p>
                Le contrevenant reconnu coupable pour une troisième fois doit
                purger une peine d'emprisonnement d'au moins 120 jours.
            </p>
            <p>
                Selon les circonstances et la gravité de l'infraction, la peine
                imposée peut aller jusqu'à 10 ans.
            </p>
            <table>
                <tr>
                    <td>
                        <p>
                            <strong>
                                Comment éviter la peine d’emprisonnement
                                obligatoire ?
                            </strong>
                        </p>
                        <p>
                            Pour éviter la peine d'emprisonnement obligatoire de
                            120 jours, il est absolument nécessaire de faire
                            appel à un avocat spécialisé en droit criminel.
                        </p>
                        <p>
                            L’avocat de la défense peut, pour éviter cette peine
                            d’emprisonnement obligatoire, négocier avec la
                            poursuite afin qu’il ne dépose pas l’avis de
                            récidive au tribunal.
                        </p>
                        <p>
                            Il se peut que l’avocat parvienne à un compromis
                            avec le procureur pour que, moyennant une
                            reconnaissance de culpabilité de la part du
                            contrevenant, l’avis de récidive ne soit pas déposé,
                            ce qui permettrait d’éviter que le tribunal impose
                            la peine minimale d’emprisonnement obligatoire de
                            120 jours.
                        </p>
                        <p>
                            Cette stratégie peut aussi être utilisée pour une
                            deuxième condamnation, permettant ainsi d’éviter la
                            peine minimale d'emprisonnement obligatoire de 30
                            jours.
                        </p>
                    </td>
                </tr>
            </table>
            <p>
                <Img
                    fluid={data.img4.childImageSharp.fluid}
                    title="Éviter une peine d’emprisonnement pour alcool au volant !"
                    alt=""
                />
            </p>
            <h4>
                <strong>3) Suspension et saisie immédiate du permis</strong>
            </h4>
            <p>
                Lors de l'arrestation, le conducteur verra son permis de
                conduire suspendu immédiatement pour{' '}
                <strong>une période de 90 jours.</strong>
            </p>
            <p>
                Le véhicule du conducteur sera également saisi pour une durée de
                90 jours.
            </p>
            <h4>
                <strong>
                    4) Révocation du permis de conduire et interdiction de
                    conduire
                </strong>
            </h4>
            <p>
                Après une déclaration de culpabilité pour une troisième
                infraction, le permis de conduire du contrevenant sera révoqué
                pour une période de trois à cinq ans, voire plus, en fonction de
                la décision du tribunal.
            </p>
            <p>
                Une interdiction de conduire d'une durée minimale de 2 ans sera
                imposée, cette période pouvant être prolongée selon les
                circonstances.
            </p>
            <h4>
                <strong>
                    5) Installation d'un antidémarreur éthylométrique à vie
                </strong>
            </h4>
            <p>
                L'installation d'un antidémarreur éthylométrique à vie sur le
                véhicule du condamné peut être ordonnée.
            </p>
            <p>
                Il n'est pas possible de demander le retrait de cet appareil
                après 10 ans. Cette mesure est permanente.
            </p>
            <h4>
                <strong>
                    6) Interdiction d'immatriculer, acquérir, louer ou mettre en
                    circulation un véhicule
                </strong>
            </h4>
            <p>
                Le contrevenant est interdit d'immatriculer, d'acquérir, de
                louer ou de mettre en circulation un véhicule à son nom.
            </p>
            <h4>
                <strong>7) Obtention d’un permis restreint</strong>
            </h4>
            <p>
                Il est possible d'obtenir un{' '}
                <Link to="https://avocatsalcoolauvolant.ca/garder-permis-alcool-volant/">
                    permis restreint
                </Link>{' '}
                après 6 mois, à condition que le véhicule soit équipé d'un
                antidémarreur éthylométrique. Le permis restreint permet à la
                personne condamnée de conduire sous certaines conditions.
            </p>
            <p>
                <Img
                    fluid={data.img5.childImageSharp.fluid}
                    title="Obtenez un permis restreint après une infraction d'alcool au volant !"
                    alt=""
                />
            </p>
            <p>
                Si le contrevenant conduit un véhicule
                <strong> sans antidémarreur</strong>, il risque des sanctions
                supplémentaires telles que:{' '}
            </p>
            <ul>
                <li>La saisie du véhicule, </li>
                <li>Une amende pouvant atteindre 3 000 $, </li>
                <li>Une suspension de son permis.</li>
            </ul>
            <h2>
                <strong>
                    Est-il possible de récupérer son permis de conduire après
                    une troisième condamnation pour alcool au volant ?
                </strong>
            </h2>
            <p>
                Lorsqu’une personne est reconnue coupable d’une troisième
                infraction de conduite avec les facultés affaiblies par l’alcool
                en moins de 10 ans, elle pourra tout de même récupérer son
                permis dans certaines circonstances.{' '}
            </p>
            <h4>
                <strong>Étape 1 – Réception de la lettre de la SAAQ</strong>
            </h4>
            <p>
                Dès le jugement du tribunal, le condamné reçoit une lettre de la
                SAAQ. Cette lettre confirme plusieurs informations essentielles,
                notamment:{' '}
            </p>
            <ul>
                <li>La culpabilité de l'individu, </li>
                <li>La révocation de son permis de conduire, et </li>
                <li>La date à partir de laquelle la sanction prend fin.</li>
            </ul>
            <p>
                Elle précise aussi si la personne est admissible à un permis
                restreint, si cela s'applique, et l'obligation de conduire un
                véhicule équipé d’un antidémarreur éthylométrique à vie.
            </p>
            <h4>
                <strong>Étape 2 – Admissibilité à la condition X</strong>
            </h4>
            <p>
                Un mois avant la fin de la sanction, la SAAQ enverra une seconde
                lettre si la personne est admissible à un permis assorti de la
                condition X, stipulant que le conducteur ne peut conduire qu’un
                véhicule équipé d’un antidémarreur.
            </p>
            <p>
                <strong>
                    Étape 3 – Location et installation de l’antidémarreur
                    éthylométrique
                </strong>
            </p>
            <p>
                La personne devra louer et faire installer un anti-démarrage.
                Les montants à payer seront à la charge du conducteur. Cet
                appareil est nécessaire pour pouvoir conduire à nouveau un
                véhicule.
            </p>
            <p>
                Les frais d’installation d’un antidémarreur éthylométrique sont
                de 50 $ plus taxes, et la location mensuelle est d’environ 61 $
                plus taxes. D’autres frais peuvent s’appliquer.
            </p>
            <p>
                Si vous conduisez un véhicule sans antidémarreur, votre véhicule
                sera saisi et vous aurez une contravention d’environ 2 000$.
                Votre permis sera suspendu pour une période supplémentaire.{' '}
            </p>
            <h4>
                <strong>Étape 4 – Obtention du nouveau permis</strong>
            </h4>
            <p>
                Après avoir satisfait à toutes les exigences, la personne peut
                demander un nouveau permis de conduire. Les frais associés à son
                obtention varient entre 420 $ et 560 $, selon les circonstances
                spécifiques de chaque dossier.
            </p>
            <h2>
                <strong>
                    Vous êtes accusé pour la troisième fois de conduite avec les
                    facultés affaiblies ? Consultez un avocat spécialisé en
                    droit criminel !
                </strong>
            </h2>
            <p>
                Vous êtes accusé pour une troisième fois de conduite avec les
                facultés affaiblies par l’alcool. Les conséquences sont sévères,
                comprenant la suspension et la révocation de votre permis de
                conduire, ainsi qu’une peine d’emprisonnement obligatoire.
            </p>
            <p>
                <Img
                    fluid={data.img6.childImageSharp.fluid}
                    title="Avocat pour troisième infraction d’alcool au volant!"
                    alt=""
                />
            </p>
            <p>
                Un avocat expérimenté pourra proposer une défense adaptée à
                votre situation et, si les circonstances le permettent, viser un
                acquittement ou, dans le cas contraire, minimiser les
                conséquences de cette troisième condamnation. Ne sous-estimez
                pas l'importance de l’intervention d’un avocat, car cela peut
                véritablement influencer le résultat de votre affaire!
            </p>
            <p>
                <strong>
                    Grâce à notre formulaire simple et gratuit, trouvez
                    rapidement un avocat en droit criminel! Après votre demande,
                    nous vous mettrons en contact avec un avocat près de chez
                    vous.
                </strong>
            </p>
            <p>
                <strong>
                    Ce service est sans engagement et 100 % gratuit, vous
                    permettant de prendre une décision en toute sérénité.
                </strong>
            </p>
        </SeoPage>
    )
}

export default ContentPage

export const pageQuery = graphql`
    query ($language: String!) {
        locales: allLocale(filter: { language: { eq: $language } }) {
            edges {
                node {
                    ns
                    data
                    language
                }
            }
        }
        img0: file(
            relativePath: {
                eq: "troisieme-infraction-alcool-volant/sanctions-conduite-facultes-affaiblies-alcool.jpeg"
            }
        ) {
            childImageSharp {
                fluid(maxWidth: 960) {
                    ...GatsbyImageSharpFluid
                }
            }
        }
        img1: file(
            relativePath: {
                eq: "troisieme-infraction-alcool-volant/saisir-vehicule-arrestation-alcool-volant.jpeg"
            }
        ) {
            childImageSharp {
                fluid(maxWidth: 960) {
                    ...GatsbyImageSharpFluid
                }
            }
        }
        img2: file(
            relativePath: {
                eq: "troisieme-infraction-alcool-volant/consequences-deuxieme-infraction-alcool-volant.jpeg"
            }
        ) {
            childImageSharp {
                fluid(maxWidth: 960) {
                    ...GatsbyImageSharpFluid
                }
            }
        }
        img3: file(
            relativePath: {
                eq: "troisieme-infraction-alcool-volant/consequences-troisieme-infraction-alcool-volant.jpeg"
            }
        ) {
            childImageSharp {
                fluid(maxWidth: 960) {
                    ...GatsbyImageSharpFluid
                }
            }
        }
        img4: file(
            relativePath: {
                eq: "troisieme-infraction-alcool-volant/eviter-prison-alcool-volant.jpeg"
            }
        ) {
            childImageSharp {
                fluid(maxWidth: 960) {
                    ...GatsbyImageSharpFluid
                }
            }
        }
        img5: file(
            relativePath: {
                eq: "troisieme-infraction-alcool-volant/avocat-troisieme-infraction-alcool-volant.jpeg"
            }
        ) {
            childImageSharp {
                fluid(maxWidth: 960) {
                    ...GatsbyImageSharpFluid
                }
            }
        }
        img6: file(
            relativePath: {
                eq: "troisieme-infraction-alcool-volant/avocat-troisieme-infraction-alcool-volant.jpeg"
            }
        ) {
            childImageSharp {
                fluid(maxWidth: 960) {
                    ...GatsbyImageSharpFluid
                }
            }
        }
    }
`
